import React from 'react';
import styled from 'styled-components';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Column } from '@prisjakt/ui/list/variants';
import { layout } from '@prisjakt/ui-base';
import {
  H3Text,
  BodyMediumText,
  FontColor,
  FontScale,
  FontWeight,
} from '@prisjakt/ui/text/variants';

import { PopularSearches } from 'src/components/popular-searches';

import { PopularSearch } from 'src/types';
import { useShowFeedback } from 'src/hooks/use-show-feedback';
import { useLocalStorage } from 'src/hooks/use-localstorage';
import { useEffectOnMount } from 'src/hooks/useEffectOnMount';

const ONE_DAY = 86400 * 1000;

type Props = {
  onRender?: () => void;
  popularSearches?: (PopularSearch | null)[];
  feedbackForm?: React.ReactNode;
};

export const NoSearchResults = (props: Props) => {
  const { t } = useAppContext();
  const { popularSearches, feedbackForm } = props;

  const [searchRelevancyFeedbackTime] = useLocalStorage(
    'pj:searchRelevancyFeedbackTime',
    0
  );

  const showRelevancyFeedback = useShowFeedback(
    0.1,
    ONE_DAY * 2,
    searchRelevancyFeedbackTime
  );

  useEffectOnMount(() => {
    if (props.onRender) props.onRender();
  });

  return (
    <>
      <NoResult gap={1}>
        <BodyMediumText
          scale={FontScale.XXL}
          weight={FontWeight.HEAVIEST}
          color={FontColor.PRIMARY}
        >
          ¯\_(ツ)_/¯
        </BodyMediumText>
        <H3Text style={{ margin: 0 }}>
          {t('search', 'search.no-results-title')}
        </H3Text>
        <BodyMediumText>
          {t('search', 'search.no-results-subtitle')}
        </BodyMediumText>
      </NoResult>

      {feedbackForm && showRelevancyFeedback ? feedbackForm : null}

      {popularSearches?.length ? (
        <>
          <PopularSearchesTitle>
            {t('search', 'search.popular-searches')}
          </PopularSearchesTitle>
          <PopularSearches popularSearches={popularSearches} />
        </>
      ) : null}
    </>
  );
};

export const NoResult = styled(Column)`
  text-align: center;
  padding: 0 ${layout.measurements.spacing100};
  margin: ${layout.measurements.spacing300} 0;
`;

const PopularSearchesTitle = styled(H3Text)`
  text-align: left;
  padding: 0 ${layout.measurements.spacing100};
  margin: ${layout.measurements.spacing100} 0;
`;
